module.exports = __webpack_public_path__ + "img/Angular_certificate.f3d3756f.webp";